export const ROLES = [
  "Senior Survey CAD Technician",
  "Junior Survey CAD Technician",
  "Land Survey CAD Drafter",
  "AutoCAD Survey Drafting Specialist",
  "Civil 3D Survey Technician",
  "Survey Data Processing Technician",
  "CAD Quality Control Reviewer",
  "Project Coordinator — Survey Drafting",
  "General application / future opportunities",
];
